module.exports = __webpack_public_path__ + "img/traveller-idle.65a36d12.svg";